import {
  AngularFirestore,
  AngularFirestoreCollection,
  CollectionReference
} from "@angular/fire/firestore";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import * as firebase from "firebase";
import { Order } from "../order/order.model";
import { Timeframe } from "../models/timeframe";
import { environment } from "src/environments/environment";

export class OrderApi {
  public collection: AngularFirestoreCollection<Order>;
  public venue_collection: AngularFirestoreCollection<Order>;
  public venue_reference: CollectionReference;
  constructor(public db: AngularFirestore) { }

  getAll(): Observable<Order[]> {
    this.collection = this.db.collection(environment.orders);
    return this.collection.snapshotChanges().pipe(
      map(actions => {
        return actions.map(action => {
          var data = action.payload.doc.data();
          var ref = action.payload.doc.ref;
          return new Order(data, ref);
        });
      })
    );
  }
  getVenueOrders(timeframe: Timeframe, venue: string): Observable<Order[]> {
    this.venue_collection = this.db.collection(environment.orders, ref =>
      ref
        .where("venue.name", "==", venue)
        .where(
          "summary.purchasedAt",
          ">=",
          firebase.firestore.Timestamp.fromDate(timeframe.begin)
        )
        .where(
          "summary.purchasedAt",
          "<=",
          firebase.firestore.Timestamp.fromDate(timeframe.end)
        )
        .orderBy("summary.purchasedAt", "desc")
    );
    return this.venue_collection.snapshotChanges().pipe(
      map(actions => {
        return actions.map(action => {
          var data = action.payload.doc.data();
          var ref = action.payload.doc.ref;
          return new Order(data, ref);
        });
      })
    );
  }

  async getNewUsers(timeframe: Timeframe): Promise<number> {
    const query = await this.db
      .collection<Order>(environment.users, ref =>
        ref
          .where(
            "created_at",
            ">=",
            firebase.firestore.Timestamp.fromDate(timeframe.begin)
          )
          .where(
            "created_at",
            "<=",
            firebase.firestore.Timestamp.fromDate(timeframe.end)
          )
          .orderBy("created_at", "desc")
      )
      .get()
      .toPromise();
    return query.docs.length;
  }

  async redeem(order: Order) {
    await order.reference.update({
      "summary.redeemedAt": firebase.firestore.Timestamp.now()
    });
  }
  async unredeem(order: Order) {
    if (order.menu?.tipRecipient != null) {
      await order.reference.update({ "summary.redeemedAt": null, "menu.tipRecipient": null })
    } else
      await order.reference.update({ "summary.redeemedAt": null });
  }
}
